import * as Effects from "redux-saga/effects";
import content from "../content";
import { ProjectActions } from "../reducers/project/actionsNames";

function* fetchContent() {
    const response = yield fetch(process.env.REACT_APP_API_URL + "/content/", {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
    });

    let contents = yield response.json();
    content.setContent(contents);
    yield Effects.put({ type: ProjectActions.InsertContent, content: contents });
}

export default function* () {
    yield Effects.takeLatest(ProjectActions.FetchContent, fetchContent);
}
